import React from "react";
import {
  Box,
  Container,
  Grid,
  Avatar,
  Typography,
  Button,
} from "@mui/material";
import { Groups, RocketLaunch, Tune } from "@mui/icons-material";
import { Card, SectionTitle, useContactDialog } from "../../../common";
import {
  colors,
  spacing,
  typography,
  shadows,
  borderRadius,
} from "../../../../theme/tokens";
import UserList from "../info/UserList.json";

type Member = {
  name: string;
  avatar: string;
  charge: string;
  values: string;
};

const MEMBERS: Member[] = UserList.user;

const COMPANY = [
  { k: "グループ名", v: "Lamact(ラマクト)" },
  { k: "設立", v: "2022年" },
  { k: "メンバー", v: "3名" },
  {
    k: "事業内容",
    v: "Webシステム開発 / UI・UXデザイン / 自社サービスの企画・運営",
  },
  { k: "所在地", v: "東京都江東区" },
  { k: "お問い合わせ", v: "公式LINEアカウントより受付" },
];

const REASONS = [
  {
    step: "01",
    icon: <Groups sx={{ fontSize: "1.6rem" }} />,
    title: "小さなチームだからこその柔軟な伴走",
    desc: "決まったパッケージに当てはめるのではなく、やりたいことの規模や予算、スケジュールに合わせて必要な機能だけを一緒に考えます。",
  },
  {
    step: "02",
    icon: <RocketLaunch sx={{ fontSize: "1.6rem" }} />,
    title: "企画からリリースまでワンストップ",
    desc: "要件整理・UI/UXデザイン・開発・公開後の運用まで、窓口を分けずに同じメンバーが最後まで並走します。",
  },
  {
    step: "03",
    icon: <Tune sx={{ fontSize: "1.6rem" }} />,
    title: "エンジニアとデザイナーが直接対応",
    desc: "間に営業や複数の担当者を挟まず、つくる本人が直接ヒアリングから携わるので、意図のズレが起きにくく意思決定も速いです。",
  },
];

function About() {
  const { open: openContactDialog } = useContactDialog();

  return (
    <Box id="about" sx={{ scrollMarginTop: { xs: "72px", md: "100px" } }}>
      {/* <Container maxWidth="md" sx={{ pt: { xs: 8, md: 12 } }}>
        <Typography
          variant="h3"
          sx={{
            fontSize: typography.fontSize["2xl"],
            fontWeight: typography.fontWeight.bold,
            textAlign: "center",
          }}
        >
          はじまりは、「何か面白いものを作ろうぜ」
        </Typography>
        <Typography
          sx={{
            mt: spacing[500],
            fontSize: typography.fontSize.base,
            color: colors.neutral[600],
            lineHeight: typography.lineHeight.relaxed,
            textAlign: "center",
          }}
        >
          Lamactは、"面白いものを0から作りたい"という気持ちで集まった仲間から始まりました。
          紆余曲折を経て、今は気心の知れた3人に。
          人数は変わっても、「作りたいから作る」という空気は変わっていません。
        </Typography>

        <Typography
          variant="h3"
          sx={{
            mt: spacing[1200],
            fontSize: typography.fontSize["2xl"],
            fontWeight: typography.fontWeight.bold,
            textAlign: "center",
          }}
        >
          受託を始めた理由
        </Typography>
        <Typography
          sx={{
            mt: spacing[500],
            fontSize: typography.fontSize.base,
            color: colors.neutral[600],
            lineHeight: typography.lineHeight.relaxed,
            textAlign: "center",
          }}
        >
          0→1で自由に作るものづくりを続ける中で、「誰かのために、期限を持ってつくる」経験もしてみたいと思うようになりました。
          そんな時、たまたま「ツグナギシケン」というリアル体験型デスゲームイベントのシステム開発を依頼されました。
          スケジュールに沿って形にしていく過程は、想像以上に楽しく、やりがいのあるものでした。
          <br />
          <br />
          それから私たちは、自分たちのために作る「開発室」と、誰かのために作る「受託」の両方を、大事にするようになりました。
        </Typography>
      </Container> */}

      {/* <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }}>
        <SectionTitle en="WHY LAMACT" ja="選ばれる理由" />
        <Grid container spacing={4}>
          {REASONS.map((r) => (
            <Grid item xs={12} sm={6} md={4} key={r.step}>
              <Card sx={{ p: spacing[800], height: "100%" }}>
                <Box
                  sx={{
                    width: "52px",
                    height: "52px",
                    borderRadius: borderRadius.lg,
                    backgroundColor: colors.primary[50],
                    color: colors.primary[600],
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {r.icon}
                </Box>
                <Typography
                  sx={{
                    mt: spacing[500],
                    fontSize: typography.fontSize.xs,
                    fontWeight: typography.fontWeight.semibold,
                    color: colors.primary[600],
                    fontFamily: typography.fontFamily.mono,
                    letterSpacing: typography.letterSpacing.widest,
                  }}
                >
                  {r.step}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    mt: spacing[100],
                    fontWeight: typography.fontWeight.bold,
                  }}
                >
                  {r.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    mt: spacing[300],
                    color: colors.neutral[600],
                    lineHeight: typography.lineHeight.relaxed,
                  }}
                >
                  {r.desc}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container> */}

      {/* <Container maxWidth="md" sx={{ py: { xs: 8, md: 12 } }}>
        <SectionTitle en="MEMBER" ja="メンバー" />
        <Box
          sx={{
            mt: spacing[800],
            display: "flex",
            flexDirection: "column",
            gap: spacing[600],
          }}
        >
          {MEMBERS.map((m) => (
            <Card
              key={m.name}
              sx={{
                p: spacing[700],
                display: "flex",
                gap: spacing[700],
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Avatar
                src={m.avatar}
                alt={m.name}
                sx={{
                  width: 96,
                  height: 96,
                  border: `2px solid ${colors.primary[100]}`,
                  boxShadow: shadows.sm,
                }}
              />
              <Box sx={{ flex: 1, minWidth: "220px" }}>
                <Typography
                  sx={{
                    fontSize: typography.fontSize.xs,
                    fontWeight: typography.fontWeight.semibold,
                    color: colors.primary[600],
                    letterSpacing: typography.letterSpacing.wider,
                  }}
                >
                  {m.charge}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    mt: spacing[100],
                    fontWeight: typography.fontWeight.bold,
                  }}
                >
                  {m.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    mt: spacing[300],
                    color: colors.neutral[600],
                    lineHeight: typography.lineHeight.relaxed,
                  }}
                >
                  {m.values}
                </Typography>
              </Box>
            </Card>
          ))}
        </Box>
      </Container> */}

      <Box sx={{ backgroundColor: colors.neutral[50], py: { xs: 8, md: 12 } }}>
        <Container maxWidth="md">
          <SectionTitle en="ABOUT US" ja="会社について" />
          <Box
            sx={{
              mt: spacing[800],
              backgroundColor: colors.neutral[0],
              borderRadius: "16px",
              border: `1px solid ${colors.neutral[200]}`,
              overflow: "hidden",
            }}
          >
            {COMPANY.map((row, i) => (
              <Box
                key={row.k}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: spacing[600],
                  px: spacing[700],
                  py: spacing[500],
                  borderTop: i ? `1px solid ${colors.neutral[200]}` : "none",
                }}
              >
                <Typography
                  sx={{
                    width: "130px",
                    flexShrink: 0,
                    fontSize: typography.fontSize.sm,
                    fontWeight: typography.fontWeight.semibold,
                    color: colors.neutral[500],
                  }}
                >
                  {row.k}
                </Typography>
                <Typography
                  sx={{
                    flex: 1,
                    fontSize: typography.fontSize.sm,
                    color: colors.neutral[900],
                    lineHeight: typography.lineHeight.relaxed,
                  }}
                >
                  {row.v}
                </Typography>
              </Box>
            ))}
          </Box>

          <Box sx={{ mt: spacing[1000], textAlign: "center" }}>
            <Button
              variant="contained"
              onClick={openContactDialog}
              sx={{
                backgroundColor: colors.primary[600],
                color: colors.neutral[0],
                px: spacing[800],
                py: spacing[400],
                fontSize: typography.fontSize.base,
                fontWeight: typography.fontWeight.medium,
                borderRadius: borderRadius.full,
                "&:hover": { backgroundColor: colors.primary[700] },
              }}
            >
              まずはご相談ください →
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

export default About;
